export enum SupertokensStatus {
    LOGGED_IN = 'logged-in',
    NEEDS_REFRESH = 'needs-refresh',
    NOT_LOGGED_IN = 'not-logged-in',
    UNKNOWN = 'unknown',
}
